/* eslint-disable no-undef */
import { styled } from '@mui/material';
import PriceBar from '@assets/images/PriceBar.png';

export const Styles = {
  CardContainer: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    flex: '0 1 auto',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    background: '#f1f1f1',
    border: '1px solid #ddd',
    height: '100%', // ocupa toda a altura da célula da grid
    borderRadius: '3px',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      minHeight: '300px'
    }
  })),

  // ImageContainer: styled('div')({
  //   position: 'relative',
  //   width: '100%',
  //   height: '280px',
  //   overflow: 'hidden'
  // }),
  Image: styled('img')({
    width: '100%',
    height: '280px',
    objectFit: 'cover',
    display: 'block'
  }),

  EmptyImage: styled('div')({
    width: '100%',
    height: '280px', // mesma altura da imagem
    backgroundColor: '#e0e0e0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box'
  }),

  IconImg: styled('img')({
    width: '16px',
    height: '16px'
  }),

  Footer: styled('div')<{ hover: boolean }>(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    flex: '1 1 auto', // ocupa o espaço restante
    marginTop: 0,
    backgroundColor: '#f1f1f1',
    padding: '0.5em 1em',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    borderTop: '1px solid #ddd',
    minHeight: 0 // evita overflow interno quando crescer
  })),

  FooterTextContainer: styled('div')({
    paddingTop: '-5px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flex: 1,
    width: '100%'
  }),

  Info: styled('p')(({ theme }) => ({
    margin: '0 0.3rem',
    color: '#5D5F64',
    fontSize: '0.9rem',
    textAlign: 'center',
    paddingTop: '0',
    alignSelf: 'self-start'
    /*
     * Este trecho comentado implementa uma fonte responsiva
     * Estudar melhor forma de aplicar sem prejudicar o layout
     *
    fontSize: 'clamp(0.7rem, 2vw, 0.9rem)',
    [theme.breakpoints.up('sm')]: {
      fontSize: 'clamp(0.7rem, 1.5vw, 0.9rem)'
    },

    [theme.breakpoints.up('md')]: {
      fontSize: 'clamp(0.7rem, 1vw, 0.9rem)'
    }
    */
  })),

  Text: styled('div')({
    display: 'flex',
    fontSize: '15px',
    fontWeight: 'bold',
    color: '#5D5F64'
    // padding: '5px'
    // margin: '-15px 20px'
  }),

  CodText: styled('div')({
    paddingTop: '5px',
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-start',
    fontSize: '15px',
    fontWeight: 'bold',
    color: '#5D5F64'
  }),

  Icons: styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: '0.5em',
    margin: '0px auto',
    width: '90%',
    boxSizing: 'border-box',
    alignItems: 'baseline'
  })),

  IconBox: styled('div')(({ theme }) => ({
    maxHeight: '20px',
    display: 'flex',
    margin: '0.5rem 0',
    alignItems: 'flex-end',
    [theme.breakpoints.up('sm')]: {
      margin: '0.5rem'
    }
  })),

  ImageContainer: styled('div')({
    position: 'relative',
    width: '100%',
    height: '250px',
    minHeight: '250px',
    flex: '0 0 250px', // impede encolher e fixa a altura da imagem
    overflow: 'hidden'
  }),
  PropertyPosition: styled('div')({
    display: 'flex',
    position: 'absolute',
    top: '10px',
    right: '0px'
  }),
  OperationTag: styled('div')<{ isAluguel: boolean }>(
    ({ theme, isAluguel }) => ({
      position: 'absolute',
      background: isAluguel ? '#a24f14' : '#236e45',
      color: '#fff',
      transform: 'rotate(43deg)',
      width: '200px',
      height: '24px',
      fontWeight: '700',
      textAlign: 'center',
      bottom: '30px',
      left: '-50px',
      fontSize: '14px',
      lineHeight: '24px',
      textTransform: 'uppercase'
    })
  )
};
